var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "sc-modal",
    {
      attrs: { active: _vm.modal.reportProblem.showModal },
      on: {
        "update:active": function($event) {
          _vm.$set(_vm.modal.reportProblem, "showModal", $event)
        }
      }
    },
    [
      _c(
        "sc-modal-card",
        { attrs: { title: _vm.modal.reportProblem.title } },
        [
          _c(
            "template",
            { attrs: { slot: "body" }, slot: "body" },
            [
              _c("create-window", {
                on: {
                  submit: function(fieldsWindow) {
                    return _vm.addWindow(_vm.fields, fieldsWindow)
                  },
                  closeModal: function($event) {
                    _vm.modal.reportProblem.showModal = false
                  }
                }
              }),
              _vm._v(" "),
              _c(
                "form",
                {
                  staticClass: "report-problem-form",
                  on: {
                    submit: function($event) {
                      $event.preventDefault()
                      _vm.onSubmitReportProblem($event)
                    }
                  }
                },
                [
                  _c("sc-input", {
                    attrs: {
                      "v-model": _vm.modal.reportProblem.model.email,
                      placeholder: "Digite o email para entrarmos em contato"
                    }
                  }),
                  _vm._v(" "),
                  _c("sc-input", {
                    attrs: {
                      "v-model": _vm.modal.reportProblem.model.description,
                      placeholder: "Descrição do problema"
                    }
                  }),
                  _vm._v(" "),
                  _c("sc-button", {
                    staticClass: "is-fullwidth",
                    attrs: {
                      theme: "primary",
                      text: _vm.sendEmailButton,
                      disabled: _vm.loading,
                      icon: "paper-plane"
                    },
                    on: {
                      click: function() {
                        return _vm.onSubmitReportProblem()
                      }
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0a5aeee1", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0a5aeee1","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./node_modules/@intelipost-modules/secure-integrations/components/modal/report-problem/ModalReportProblem.vue
// module id = null
// module chunks = 